exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.yubikey-factor-component .ant-input-affix-wrapper input.ant-input {\n  padding-left: 55px !important;\n}\n", ""]);

// exports
